var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      staticClass: "item",
      attrs: { effect: "dark", content: "Refresh data", placement: "top" },
    },
    [
      _c(
        "a",
        {
          on: {
            click: function ($event) {
              return _vm.refreshProducts()
            },
          },
        },
        [_c("i", { class: _vm.iconClass })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }